export const isEmptyValue = (value: string) => {
  if (value && value.length > 0) {
    return false;
  }
  return true;
};

export const isEmptyObject = (obj: Record<string, unknown>) =>
  Object.keys(obj).length === 0;
